import React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

const TickInCircle = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.8"
    >
      <path
        d="M8 0.5C9.38256 0.5 10.674 0.876699 11.7842 1.53223L11.3447 1.9707C10.3542 1.4174 9.21808 1.09961 8 1.09961C4.18786 1.09961 1.09961 4.18786 1.09961 8C1.09961 11.8121 4.18786 14.9004 8 14.9004C11.8121 14.9004 14.9004 11.8121 14.9004 8C14.9004 7.56742 14.8524 7.14417 14.7754 6.73926L15.2812 6.2334C15.421 6.80158 15.5 7.39238 15.5 8C15.5 12.1399 12.1399 15.5 8 15.5C3.86014 15.5 0.5 12.1399 0.5 8C0.5 3.86014 3.86014 0.5 8 0.5ZM15.291 2.54492L6.87109 10.9717L4.1875 8.28809L4.6084 7.86719L6.87207 10.1309L7.22559 9.77734L14.8721 2.12988L15.291 2.54492Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export default TickInCircle;
